module.exports = __webpack_public_path__ + "static/media/fly0102.e91d9cc7.webp";